<template>
  <section class="ph-16 pv-32">
    <div class="u-txt--center mb-48">
      <bl-text-av class="mb-8" tag="h2" variation="heading-24" weight="bold">
        {{ $options.productList.title }}
      </bl-text-av>

      <bl-text-av variation="body-14">
        {{ $options.productList.subtitle }}
      </bl-text-av>
    </div>

    <div v-if="mutualFundProducts">
      <article v-for="(product, index) in filteredProducts" :key="product.id">
        <product-card :class="{ 'mt-32': index !== 0 }" :product="product" />
      </article>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import { ProductList as productList } from 'shared/modules/seo/Homepage';
import ProductCard from 'seo-mobile/components/ProductCard';

export default {
  name: 'ProductList',

  productList,

  components: {
    BlTextAv,
    ProductCard,
  },

  computed: {
    mutualFundProducts() {
      return this.$store.state.server.mutualFundProducts;
    },
    filteredProducts() {
      return this.mutualFundProducts && this.mutualFundProducts.filter(product => product.recommended);
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundProducts) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundProducts');
    }
  },
};
</script>
